import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

// Import your dashboard icons (PNG/SVG)
import profileImg from "../assets/images/dahboard/profileicon.svg";
import passwordImg from "../assets/images/dahboard/passwordicon.svg";
import familyImg from "../assets/images/dahboard/membersicon.svg";
import membershipImg from "../assets/images/dahboard/membershipicon.svg";
import ticketImg from "../assets/images/dahboard/eventtickets.svg";
import transactionImg from "../assets/images/dahboard/transaction.svg";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentStatusModal from "../components/common/PaymentStatusModal";


const Dashboarddetails = [
  {
    id: 1,
    title: "My Profile",
    text: "View and update your personal information",
    img: profileImg,
    path: "/profile",
  },
  {
    id: 2,
    title: "Change Password",
    text: "Update your account password",
    img: passwordImg,
    path: "/change-password",
  },
  {
    id: 3,
    title: "Family Members",
    text: "Manage your family members",
    img: familyImg,
    path: "/family-member",
  },
  {
    id: 4,
    title: "Membership",
    text: "View and update your membership details",
    img: membershipImg,
    path: "/membership",
  },
  {
    id: 5,
    title: "Transactions",
    text: "View and download receipts of your transactions",
    img: transactionImg,
    path: "/transactions",
  },
  {
    id: 6,
    title: "Event Tickets",
    text: "View your event tickets",
    img: ticketImg,
    path: "/event-ticket",
  },
];

function DashboardCard({ item }) {
  const navigate = useNavigate();
  const { title, text, img, path } = item;

  const handleClick = () => {
    if (path) navigate(path);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <Card
      className="dashboard-card border-0"
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label={title}
    >
      <Card.Body className="d-flex gap-4 flex-column p-4 border-0">
        <div className="icon-wrap">
          <img src={img} alt={title} className="dashboard-card-icon" />
        </div>
        <div>
          <Card.Title className="mb-1 fw-semibold f-16">{title}</Card.Title>
          <Card.Text className="fw-normal mb-0 f-14">{text}</Card.Text>
          {/* <div className="mt-3">
          <button
            className="btn btn-orange light-orange-bg d-flex align-items-center gap-2"
          >
            <span className="profile-btn-text">Go to Profile</span>

            <span className="profile-btn-icon">
              <FaArrowRight size={12} />
            </span>
          </button>
          </div> */}
        </div>
      </Card.Body>
    </Card>
  );
}

export default function Dashboard() {
  const { user } = useSelector((state) => state.USER_DATA);
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = React.useState(null);

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("status");
    const autoLogin = params.get("auto_login") === "true";
    const convergeId = params.get("converge_transaction_id");

    if (status === "success" && autoLogin) {
      setPaymentStatus({ status, convergeId });
    }
  }, [location]);

  const handleCloseModal = () => {
    setPaymentStatus(null);
    navigate("/dashboard", { replace: true });
  };
  const handleRedirect = () => {
    setPaymentStatus(null);
    // Remove query params from URL without reloading
    navigate("/transactions", { replace: true });
  };

  const displayName =
    `${user?.first_name || ""} ${user?.last_name || ""}`.trim() || "Guest";
  return (
    <>
      {paymentStatus && (
        <PaymentStatusModal
          status={paymentStatus?.status}
          convergeId={paymentStatus?.convergeId}
          onClose={handleCloseModal}
          onNavigate={handleRedirect}
        />
      )}
      <Container>
        <Row className="my-4 mx-auto">
          <Col lg={12}>
            <h1 className="mb-0 fw-bold text-main f-20">
              Welcome, {displayName}
            </h1>
          </Col>
        </Row>

        <Row className="g-4 mb-5 ">
          {Dashboarddetails.map((b) => (
            <Col
              key={b.id}
              lg={4}
              md={6}
              sm={12}
              xs={12}
              className="dash-card-sections"
            >
              <DashboardCard item={b} />
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}
